import { render, staticRenderFns } from "./HpadPD.vue?vue&type=template&id=31ac0f0d"
import script from "./HpadPD.vue?vue&type=script&lang=js"
export * from "./HpadPD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports